import { JobType } from "../../jobs";

export interface PreDefinedJobStatisticsChart {
    dataPoints: DataPoint[];
    chartType?: GraphTypeEnum;
    jobType?: JobType;
}

export interface UserDefinedJobStatisticsChartMetadata {
    chartId: number;
    clientId: number;
    dataPointCount: number;
    dateBlobGenerated: Date;
    filterColumns: ChartColumnEnum[];
    jobType: JobType;
    name: string;
    sqlAggregationType: SqlAggregationTypeEnum;
    xAxis: ChartColumnEnum;
    yAxis: GraphTypeEnum;
    errorMessage: string;
}

export enum ChartColumnEnum {
    ProjectRunConfigurationId = "Project Run Configuration Id",
    HasZipSummaries = "Has Zip Summaries",
    ShowNextClosestNetworkProviders = "Show Next Closest Network Providers",
    NetworkProviderCount = "Network Provider Count",
    ProspectProviderCount = "Prospect Provider Count",
    MarketProviderCount = "Market Provider Count",
    TotalProviderCount = "Total Provider Count",
    MemberCount = "Member Count",
    TotalCalculations = "Total Provider Count * Member Count",
    TotalAccessCalculations = "Total Access Calculations",
    TimeDistanceBlobsGenerated = "# of Time Distance Blobs Generated",
    NonExcludedSpecialtyGroupCount = "Non-Excluded Specialty Group Count",
    TerminatedProviderCount = "Terminated Provider Count",
    TargetedProviderCount = "Targeted Provider Count",
    RegionSetId = "Region Set Id",
    CountySSA = "County SSA",
    RunDuringBulkTargeting = "Run During Volume Targeting",
    RunDuringBulkTermination = "Run During Volume Termination",
}

export enum FilteringOptionsState {
    Negative = 0,
    Positive = 1,
}

export enum SqlAggregationTypeEnum {
    Unknown = 0,
    Min = 1,
    Max = 2,
    Avg = 3,
    Median = 4,
    Count = 5,
}

export interface UserDefinedChartParameters {
    dataPointCount?: number;
    dataPoints: DataPoint[];
    filterColumns: string[];
    jobType: JobType;
    name: string;
    sqlAggregationType: SqlAggregationTypeEnum;
    xAxis: ChartColumnEnum;
    yAxis: GraphTypeEnum;
}

export interface DataPoint {
    xAxisValue: string | number;
    yAxisValue: string | number;
}

export enum GraphTypeEnum {
    Unknown = "Unknown",
    Runtime = "Average Run Time (Minutes)",
    MaxCPU = "Average Max CPU (%)",
    MaxRAM = "Average Max RAM (MB)",
    AverageCPU = "Average CPU (%)",
    AverageRAM = "Average RAM (MB)",
    QueueTime = "Queue Time",
    Runs = "Runs",
}

export interface UserDefinedChartModel {
    dataPoints: DataPoint[];
    metadata: UserDefinedJobStatisticsChartMetadata;
}

/* Recharts defines axis tick props as "any," so we'll provide our own */
export interface PerformanceAxisTickProps {
    payload?: {
        value: number;
    };
    x?: number;
    y?: number;
}

export type PredefinedJobChartStorage = Map<JobType | "Job Count", PreDefinedJobStatisticsChart[]>;
export type UserDefinedJobChartStorage = Map<number, UserDefinedChartModel>;